module.exports = __webpack_public_path__ + "static/img/13.6443883.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/13.png
// module id = +/t2
// module chunks = 0